'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { useEffect, useMemo, useState } from 'react';
import type { CkEditorRendererProps } from '@/components/elementary/CkEditorRenderer/types';
import { ckEditorTextVariants } from '@/lib/constants';
import { cn } from '@/lib/styles';
import { CK_EDITOR_TEST_IDS } from '@/lib/test-ids';
import { processIframes, processImages, processLinks, processTagNames } from '@/lib/toc-tree';
import type { AppLocale } from '@/types/general';

/**
 * Use this variant of the CkEditorRenderer whenever you are within the client context. That means you will need to validate that the entire
 * tree in which this component is being rendered.
 */
const CkEditorCSRRendererInner = t0 => {
  const $ = _c(12);
  const {
    htmlContent,
    className,
    variant: t1,
    context: t2,
    defaultTypography: t3
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const context = t2 === undefined ? "default" : t2;
  const defaultTypography = t3 === undefined ? "default" : t3;
  const [isMounted, setIsMounted] = useState(false);
  const locale = useLocale() as AppLocale;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = new Set();
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const usedIds = t4;
  let t5;
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsMounted(true);
    };
    t6 = [];
    $[1] = t5;
    $[2] = t6;
  } else {
    t5 = $[1];
    t6 = $[2];
  }
  useEffect(t5, t6);
  let t7;
  bb0: {
    if (!isMounted) {
      t7 = undefined;
      break bb0;
    }
    if (!htmlContent) {
      t7 = "";
      break bb0;
    }
    let doc;
    if ($[3] !== htmlContent || $[4] !== locale) {
      const parser = new DOMParser();
      doc = parser.parseFromString(htmlContent, "text/html");
      processLinks(doc, locale);
      processImages(doc);
      processIframes(doc);
      processTagNames(doc, usedIds);
      $[3] = htmlContent;
      $[4] = locale;
      $[5] = doc;
    } else {
      doc = $[5];
    }
    t7 = doc.body.innerHTML;
  }
  const processedHtmlContent = t7;
  let t8;
  if ($[6] !== className || $[7] !== context || $[8] !== defaultTypography || $[9] !== processedHtmlContent || $[10] !== variant) {
    t8 = processedHtmlContent ? <div className="ck-content" data-test-id={CK_EDITOR_TEST_IDS.COMPONENT}><div className={cn(`ck-editor-${variant}`, `ck-editor-ctxt-${context}`, `ck-editor-typography-${defaultTypography !== "default" ? ckEditorTextVariants?.[defaultTypography] : defaultTypography}`, className)} dangerouslySetInnerHTML={{
        __html: processedHtmlContent
      }} /></div> : null;
    $[6] = className;
    $[7] = context;
    $[8] = defaultTypography;
    $[9] = processedHtmlContent;
    $[10] = variant;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default CkEditorCSRRendererInner;